import React, { useEffect, useRef, useState } from 'react'

import { MOBILE_VIEW_BREAKPOINT } from '../../constants'
import useHomepage from '../../hooks/useHomepage'

const WAITING_TIME_IN_SECONDS = 8000

const OneDollarLunchPromo: React.FC = () => {
  const { showModal } = useHomepage()
  const [enquedOneDollarLunchPromo, setEnquedOneDollarLunchPromo] = useState(false)
  const isMobile = typeof window != 'undefined' && window.innerWidth < MOBILE_VIEW_BREAKPOINT
  const timerRef = useRef<NodeJS.Timeout>()
  const viewedRef = useRef(false)
  const onNyLunch = typeof window != 'undefined' && window.location.pathname.indexOf('nylunch') > -1
  const onSfLunch = typeof window != 'undefined' && window.location.pathname.indexOf('sflunch') > -1

  const enqueOneDollarLunchPromo = () => {
    if (!enquedOneDollarLunchPromo && isMobile && !onNyLunch && !onSfLunch) {
      setEnquedOneDollarLunchPromo(true)
      showModal({ name: 'one-dollar-lunch-promo' })
      window.removeEventListener('scroll', onScrollHandler)
      viewedRef.current = true
    }
  }

  const onScrollHandler = () => {
    const position = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100

    if (position >= 55 && !viewedRef.current) {
      enqueOneDollarLunchPromo()
      if (timerRef !== null) {
        clearTimeout(timerRef.current)
      }
    }
  }

  const onInputFocusHandler = () => {
    clearTimeout(timerRef.current)
  }

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      enqueOneDollarLunchPromo()
    }, WAITING_TIME_IN_SECONDS)
    return () => {
      clearTimeout(timerRef.current)
    }
  })

  useEffect(() => {
    window.addEventListener('focusin', onInputFocusHandler)
    return () => {
      window.removeEventListener('focusin', onInputFocusHandler)
    }
  })

  useEffect(() => {
    const position = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
    if (position < 55) {
      window.addEventListener('scroll', onScrollHandler)
    }
    return () => {
      window.removeEventListener('scroll', onScrollHandler)
    }
  }, [])

  return null
}

export default OneDollarLunchPromo
